import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/location_new/uk-web/banner_uk_web.webp";
import Bannerfrom from "../../components/bannerfrom";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Banner(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div
        className="service_usa web_dev_service healthcare_banner android_banner"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={7} lg={6} xl={7} xxl={7} className="my-auto">
              <div className="banenr_content">
                <h1
                  className="web_head_banner"
                  style={{ marginBottom: "10px" }}
                >
                  Web Development Company in the UK
                </h1>
                <span style={{ color: "#fff" }} className="d-block mb-3">
                  User-First, Performant Web Development
                </span>
                <p>
                  Digitise your business with our high-end web development
                  services, delivering visually appealing websites with optimal
                  performance. Our agency leverages the latest technologies to
                  build a supreme product. From design to development, we craft
                  web apps that set you apart in the competitive global
                  marketplace, increasing your conversion rate.
                </p>

                <button
                  style={{ background: "#F47a14", color: "#fff" }}
                  onClick={handleShow}
                  className="border_btn"
                >
                  Request a Quote
                </button>
              </div>
            </Col>
            <Col xs={12} md={5} lg={6} xl={5} xxl={5} className="my-auto">
              <Bannerfrom />
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Banner;
